import { createSlice } from "@reduxjs/toolkit"
import {
  getEcommUpholsteries,
  Upholstery,
  UpholsteryDtoDelekComponent,
} from "api"
import { updatePriceAndURL } from "components/shopFeatures/wizard/wizardSlice"
import { createAsyncAppThunk } from "store"

const name = "upholstery"

export type UpholsteryState = {
  upholsteries: UpholsteryDtoDelekComponent[]
  selectedUpholsteryCode: Upholstery["code"]
}

const initialState: UpholsteryState = {
  upholsteries: [],
  selectedUpholsteryCode: "",
}

export const fetchUpholsteries = createAsyncAppThunk(
  `${name}/fetchUpholsteries`,
  async (
    { detailingCode, colorCode }: { detailingCode: string; colorCode: string },
    { dispatch, getState }
  ) => {
    if (!detailingCode || !colorCode) {
      return []
    }
    const {
      data: { body: upholsteries },
    } = await getEcommUpholsteries(detailingCode, colorCode)

    const selectedUpholstery = getState().upholstery.selectedUpholsteryCode
    const showOnlyStock = getState().wizard.showOnlyStock

    if (upholsteries.length === 0) {
      dispatch(setSelectedUpholstery(""))
      return []
    }

    let upholsteryToSelect = selectedUpholstery
    if (selectedUpholstery) {
      const selectedUph = upholsteries.find(
        (u) => u.details.code === selectedUpholstery
      )
      if (!selectedUph || !selectedUph.details.inStock) {
        // Selected upholstery is not in stock
        const inStockUph = upholsteries.find((u) => u.details.inStock)
        if (inStockUph) {
          upholsteryToSelect = inStockUph.details.code
        } else {
          upholsteryToSelect = showOnlyStock
            ? ""
            : upholsteries[0]?.details.code ?? ""
        }
      }
    } else {
      // No selected upholstery
      const inStockUph = upholsteries.find((u) => u.details.inStock)
      if (inStockUph) {
        upholsteryToSelect = inStockUph.details.code
      } else {
        upholsteryToSelect = showOnlyStock
          ? ""
          : upholsteries[0]?.details.code ?? ""
      }
    }
    dispatch(setSelectedUpholstery(upholsteryToSelect))
    return upholsteries
  }
)

export const setSelectedUpholstery = createAsyncAppThunk(
  `${name}/setSelectedUpholstery`,
  (
    _upholsteryCode: UpholsteryState["selectedUpholsteryCode"],
    { dispatch }
  ) => {
    dispatch(updatePriceAndURL())
  }
)

export const resetUpholsteries = createAsyncAppThunk(
  `${name}/resetUpholsteries`,
  (_, { dispatch }) => {
    dispatch(setSelectedUpholstery(""))
  }
)

const upholstery = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUpholsteries.fulfilled, (state, { payload }) => {
        state.upholsteries = payload
      })
      .addCase(setSelectedUpholstery.pending, (state, { meta }) => {
        state.selectedUpholsteryCode = meta.arg
      })
      .addCase(resetUpholsteries.pending, (state) => {
        state.upholsteries = []
      })
  },
})

export default upholstery.reducer
